<script lang="ts">
  import { STRINGS } from '$lib/constants/strings'
  import type { ReviewIncludes } from '@bond/bruce-api/api/review/response'
  import {
    Avatar,
    Button,
    Divider,
    Icon,
    type Language,
  } from '@bond/components'
  import { page } from '$app/stores'

  export let imageUrl: string
  export let reviews: ReviewIncludes<{
    params: {
      include_booking: true
      include_booking_class: true
      include_booking_user: true
    }
  }>[]
  export let initialMax = 2

  $: lang = $page.params.lang as Language
  $: shownReviews = expandReviews ? reviews : reviews.slice(0, initialMax)
  let expandReviews = false

  function toggleExpandReviews() {
    expandReviews = !expandReviews
  }
</script>

<div class="container">
  {#each shownReviews as review, index (review.id)}
    <div class="review-container">
      <div class="author">
        <Avatar
          src={review.booking.user?.photo
            ? `${imageUrl}/${review.booking.user.photo}`
            : undefined}
          alt={review.booking.user?.first_name || STRINGS[lang].ANONYMOUS}
          size={4}
        />
        <div>{review.booking.user?.first_name || STRINGS[lang].ANONYMOUS}</div>
      </div>
      <div class="review">
        <div class="rating">
          {#each Array(Math.round(review.rating)) as _, index (index)}
            <Icon icon="ph-star-fill" size={1.25} />
          {/each}
          {#each Array(5 - Math.round(review.rating)) as _, index (index)}
            <Icon icon="ph-star" size={1.25} />
          {/each}
        </div>
        {#if review.booking.class.title}
          <div>
            {review.booking.class.title}
          </div>
        {/if}
        <p>{review.comment}</p>
      </div>
      <div class="date">
        {new Date(review.created_at).toLocaleDateString(lang, {
          year: 'numeric',
          month: 'long',
        })}
      </div>
    </div>
    {#if index !== shownReviews.length - 1}
      <Divider />
    {/if}
  {/each}
  {#if reviews.length > initialMax}
    <Button type="button" rounded variant="text" on:click={toggleExpandReviews}>
      {expandReviews ? STRINGS[lang].SHOW_LESS : STRINGS[lang].SHOW_MORE}
    </Button>
  {/if}
</div>

<style lang="scss">
  .container {
    .review-container {
      position: relative;
      display: flex;
      align-items: center;
      gap: 2em;
      margin-top: 1em;

      .author {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1em;
        width: 100px;
        min-width: 100px;
        text-align: center;
        font-size: 14px;
      }

      .review {
        display: flex;
        flex-direction: column;
        gap: 0.25em;
        font-size: 18px;

        .rating {
          display: flex;
          --icon-margin: 0;
        }
      }

      .date {
        position: absolute;
        top: 0;
        right: 1em;
      }
    }
  }
</style>
